<div class="catalogSort">
  <span class="d-none d-md-inline-block" i18n="@@CATALOG.FILTERS.SORT.SORT_BY">Sort by</span>
  <button
    class="catalogSort__button d-none d-md-inline-block"
    (click)="toggleSortList()"
    [ngClass]="{open: sortListOpen}"
  >
    <ng-container [ngSwitch]="selectedSort">
      <span *ngSwitchCase="indexSortBy.Default" i18n="@@CATALOG.SORT.RELEVANCE">Relevance</span>
      <span *ngSwitchCase="indexSortBy.PriceAsc" i18n="@@CATALOG.SORT.PRICE_ASC">Price: Low to High</span>
      <span *ngSwitchCase="indexSortBy.PriceDesc" i18n="@@CATALOG.SORT.PRICE_DESC">Price: High to Low</span>
      <span *ngSwitchCase="indexSortBy.Recent" i18n="@@CATALOG.SORT.MOST_RECENT">Most recent</span>
    </ng-container>
  </button>
  <div class="catalogSort__list" [ngClass]="{open: sortListOpen}">
    <div class="catalogSort__listHeader">
      <span i18n="@@CATALOG.FILTERS.SORT.TITLE">Sort</span>
      <button aria-label="close modal" class="vc-modal__closeBtn" (click)="closeSortList()">
        <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
      </button>
    </div>
    <div class="catalogSort__listContent">
      <vc-custom-sort-by-selector (update)="updateSelectedSort($event)"></vc-custom-sort-by-selector>
    </div>
    <div class="catalogSort__listAction">
      <button
        (click)="closeSortList()"
        class="vc-btn vc-btn--primary vc-btn--large"
        i18n="@@CATALOG.FILTERS.SORT.VALIDATE_BUTTON"
      >
        Apply
      </button>
    </div>
  </div>
</div>
